import * as React from 'react';
import * as styles from '../Composer.css';
import { LocalizationService } from '../../../services/LocalizationService';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { IAPeopleSearch } from '../../peopleSearch/PeopleSearch';
import { IUser } from '../../../interfaces/IUser';
import { Helper } from '../../../Helper';

export interface IProps {
  store?: Store;
  style?: React.CSSProperties;
  onChange: () => void;
}

@inject('store')
@observer
export class Author extends React.Component<IProps> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  public componentDidMount(): void {
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const style = this.props.style ?? {};
    return (
      <div
        className={styles.IA_composerElement}
        style={{
          marginTop: 10,
          minHeight: 30,
          ...style
        }}
        onClick={() => {
          this.props.store.activeComponent = this.props.store.contacts;
        }}
      >
        <div className={styles.IA_label}>{this.localizationService.strings.Messages_EditPanel_Contacts} <span style={{ color: this.props.store.highlightColor }}>*</span></div>
        <IAPeopleSearch
          token={this.props.store.token}
          tenant={this.props.store.tenant}
          environment={this.props.store.environment}
          multiSelection={true}
          backgroundColor="#ffffff"
          placeholderText={this.localizationService.strings.Phonebook_Search}
          selectedValues={this.props.store.contacts.users}
          onSelect={(people: IUser[]) => {
            if (people != undefined) {
              people.forEach((contact: any) => {
                contact = Helper.syncUserProperties(contact);
              });
            }
            this.props.store.contacts.users = people;
            this.props.onChange();
          }}
          style={{
            width: "100%",
            clear: "both",
            border: `1px solid ${!this.props.store.validateContacts() ? "#df4f4f" : "transparent"}`
          }}
          hightlightColor={this.props.store.highlightColor}
        />
      </div>
    );
  }
}